import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../../store';
import { toggleMenuModal } from '../../store/reducers/modal/modalMenuSlice';
import { logout } from '../../store/reducers/profile/autorizationStatutsSlice';
import Login from '../Login';
import { openLoginModal } from '../../store/reducers/modal/loginModalSlice';

import Icon from '../../UI/Icon';

import bemClassName from '../../utils/bem';

import './index.scss';
import PrivateData from '../../API/PrivateData';
import { CHANGE_PASSWORD } from '../../app_constants';

const headerLinks = bemClassName('header-links');

const HeaderLinks = () => {
  const windowWidth = useSelector((state: RootState) => state.window.windowWidth);
  const contacntHelperPhones = useSelector(
    (state: RootState) => state.autorizationStatus.contacntHelperPhones,
  );
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const isPaswordVerified = useSelector(
    (state: RootState) => state.autorizationStatus.isPaswordVerified,
  );
  const bonus = useSelector((state: RootState) => state.autorizationStatus.bonus);

  // const navigate = useNavigate();

  const dispatch = useDispatch();

  const redirectToLogin = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault(); // Отменяем переход по ссылке /login в браузере
    dispatch(openLoginModal()); // Открываем модалку через Redux
  };

  const handlerLogout = async () => {
    try {
      await PrivateData.getPrivateLoggingOut().then(() => {
        dispatch(logout());
      });
    } catch {
      dispatch(logout());
    }
  };

  return (
    <div className={headerLinks()}>
      <Link className={headerLinks('item', { cart: true })} to="/account#bonus-points">
        {bonus ?? 0} ₽
      </Link>
      {windowWidth >= 768 ? (
        <>
          <Link className={headerLinks('item')} to="/account#favourites">
            <Icon externalClassName={headerLinks('icon')} iconName="like" />
            избранное
          </Link>
          <Link className={headerLinks('item')} to="/account#current-bookings">
            <Icon externalClassName={headerLinks('icon')} iconName="booking" />
            бронирования
          </Link>
          <div className={headerLinks('item')}>
            <Icon externalClassName={headerLinks('icon')} iconName="help" />
            помощь
            <div className={headerLinks('submenu-wrapper')}>
              <div className={headerLinks('submenu')}>
                <Link className={headerLinks('submenu-link')} to="#t">
                  Часто задаваемые вопросы
                </Link>
                {contacntHelperPhones &&
                  contacntHelperPhones.data &&
                  contacntHelperPhones.data.slice(0, 1).map((items, id) => {
                    return (
                      <Link
                        key={id}
                        to={`tel:${items.phone.E164}`}
                        className={headerLinks('submenu-link')}>
                        {items.phone.international}
                      </Link>
                    );
                  })}
              </div>
            </div>
          </div>
          {isLogin !== null && isLogin ? (
            <div className={headerLinks('item')}>
              {isPaswordVerified ? (
                <Icon externalClassName={headerLinks('icon')} stroke iconName="profile-success" />
              ) : (
                <Icon externalClassName={headerLinks('icon')} stroke iconName="warning" />
              )}
              кабинет
              <div className={headerLinks('submenu-wrapper')}>
                <div className={headerLinks('submenu')}>
                  {isPaswordVerified ? (
                    <Link className={headerLinks('submenu-green')} to="/account#proof-of-identity">
                      Личность подтверждена
                    </Link>
                  ) : (
                    <Link className={headerLinks('submenu-red')} to="/account#proof-of-identity">
                      Верификация не пройдена
                    </Link>
                  )}
                  <Link className={headerLinks('submenu-link')} to="/account#messages">
                    Сообщения
                  </Link>
                  {CHANGE_PASSWORD && (
                    <Link className={headerLinks('submenu-link')} to={CHANGE_PASSWORD}>
                      Сменить пароль
                    </Link>
                  )}
                  <p className={headerLinks('submenu-link')} onClick={() => handlerLogout()}>
                    Выйти
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <Link
              onClick={(event) => redirectToLogin(event)}
              className={headerLinks('item')}
              to="/login">
              <Icon externalClassName={headerLinks('icon')} stroke iconName="profile" />
              войти
            </Link>
          )}
        </>
      ) : (
        <Icon
          externalClassName={headerLinks('icon')}
          iconName="burger"
          handleClick={() => dispatch(toggleMenuModal())}
        />
      )}
      <Login />
    </div>
  );
};

export default HeaderLinks;
